// extracted by mini-css-extract-plugin
export default {"hyperlinksField":"HyperlinksField_hyperlinksField__jRs6g","linksList":"HyperlinksField_linksList__JZIDk"};